/*
 * @Date: 2025-01-08 14:20:38
 * @LastEditors: furan NgeKaworu@gmail.com
 * @LastEditTime: 2025-05-08 16:30:15
 * @FilePath: /newwork-h5/src/utils/request.js
 */
import axios from 'axios'
import router from '@/router'
import { LocaleMgr } from 'i18n'
// import { options } from 'less'

const service = axios.create({
  timeout: 30000,
})

service.interceptors.request.use(
  config => {
    const userString = localStorage.getItem('user')
    if (userString !== 'undefined' && userString != null) {
      config.headers.Authorization = JSON.parse(userString).token
    }

    config.headers.Platform = 'NEW_WORK'
    config.headers['Accept-Language'] = LocaleMgr.highestPriorityFirstLocale
    return config
  },
  error => {
    console.log('err' + error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if (res.code !== 200) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000,
    //   })

    //   // 登录信息失效
    //   if (res.code === 401) {
    //     // to re-login
    //     MessageBox.confirm(
    //       'You have been logged out, you can cancel to stay on this page, or log in again',
    //       'Confirm logout',
    //       {
    //         confirmButtonText: 'Re-Login',
    //         cancelButtonText: 'Cancel',
    //         type: 'warning',
    //       }
    //     ).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }

    return res
  },
  error => {
    console.log('err' + error) // for debug
    if (error.response.data.customCode == 401) {
      localStorage.removeItem('user')
      let cCode = localStorage.getItem('cCode')
      if (cCode) {
        let companyCode = { code: JSON.parse(cCode).code }
        localStorage.setItem('companyCode', JSON.stringify(companyCode))
        localStorage.removeItem('cCode')
      }
      router.push('/login')
    }
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 3 * 1000,
    // })
    return Promise.reject(error)
  }
)

export default service
